export const CASTING_CONFIG = {
  enterprise: false,
};
